module.exports = {
      id: "404-robot-usage",
      viewBox: "0 0 280 313",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#404-robot",
      toString: function () {
        return this.url;
      }
    }